import React, { useEffect, useState } from "react";
import { Table, Image } from "antd";
import { ColumnsType } from "antd/es/table";
import { FileOutlined } from "@ant-design/icons";
import { ContractResult } from "@/views/contract/manage/ContractManageTypes";
import { useSummaryModel } from "./summaryModel";
import { formatLocalDateTime } from "@/utils/utils";
import { useGlobalModel } from "@/model/globalModel";
import { getBaseImgLookUrl } from "@/utils/constants";

export function DataTable() {

    const { getDictNodeName } = useGlobalModel();
    const {
        loading,
        pgCfg, dataSource, loadData,
        selectedRowKeys, setSelectedRowKeys,
    } = useSummaryModel()

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    const columns: ColumnsType<ContractResult> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '合约单号',
            dataIndex: 'code',
            align: "center",
            width: 120,
            ellipsis: true,
        },
        {
            title: '',
            dataIndex: '',
            align: "center",
            width: 40,
            ellipsis: true,
            render: (t, r) => r.md5 ?
                <FileOutlined onClick={() => {
                    if (r.md5.indexOf("pdf") != -1 || r.md5.indexOf("doc") != -1) {
                        window.location.href = getBaseImgLookUrl(r.md5);
                    }
                    else {
                        setPreviewImage(getBaseImgLookUrl(r.md5));
                        setPreviewOpen(true);
                    }
                }} /> : ""
        },
        {
            title: '合约状态',
            dataIndex: 'status',
            align: "center",
            width: 80,
            ellipsis: true,
            render: t => t === 0 ? '待审核' : t === 1 ? '进行中' : t === 9 ? '已完成' : ''
        },
        {
            title: '账户类型',
            dataIndex: 'accountTypeName',
            align: "center",
            width: 80,
            ellipsis: true,
        },
        {
            title: '签约类型',
            dataIndex: 'contractType',
            align: "center",
            width: 80,
            ellipsis: true,
            render: (text) => text === null || text === '' ? "暂无" : getDictNodeName(text)
        },
        {
            title: '账户名称',
            dataIndex: 'accountName',
            align: "center",
            ellipsis: true,
        },
        {
            title: '账户实体',
            dataIndex: 'beName',
            align: "center",
            width: 200,
            ellipsis: true,
        },
        {
            title: '客户名称',
            dataIndex: 'partnerName',
            align: "center",
            width: 200,
            ellipsis: true,
        },
        {
            title: '合约起止日期',
            dataIndex: 'startTime',
            align: "center",
            width: 140,
            ellipsis: true,
            render: (text, record) => {
                let start = formatLocalDateTime(record.startTime).replaceAll("-", "/").substring(0, 10);
                let end = formatLocalDateTime(record.endTime).replaceAll("-", "/").substring(0, 10);
                return record.terminateUser == null ? <span>{start} - {end}</span> : <span>{start} - <span style={{ color: 'red' }}>{end}</span></span>;
            }
        },
        {
            title: '签约额度',
            dataIndex: 'contractAmount',
            align: "center",
            width: 80,
            ellipsis: true,
        },
        {
            align: "center",
            title: '创建人',
            dataIndex: 'createUser',
            width: 60,
        },
        {
            align: "center",
            title: '创建日期',
            dataIndex: 'createTime',
            width: 160,
            render: (text, record) => formatLocalDateTime(text)
        },

    ];

    useEffect(() => {
        loadData().then();
    }, [])

    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id]);
        }
    };

    return (
        <>
            <Table
                loading={loading}
                className='radioTableHeight'
                rowKey={record => record.id}
                rowSelection={{
                    type: "radio",
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ContractResult[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    showTotal: (total: number) => `共${total}条`,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                onRow={record => ({
                    onClick: () => onRow(record.id)
                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
            />
            <Image
                width={200}
                style={{ display: 'none' }}
                src={previewImage}
                preview={{
                    visible: previewOpen,
                    src: previewImage,
                    onVisibleChange: value => {
                        setPreviewOpen(value);
                    },
                }}
            />
        </>
    )
}

